<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {toastbox} from '../../../utils.js';
    import {validate_int} from '../../../validators.js';
    import {parameter, network, store} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";
    const user = store('credential', 'getAuth');
    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    // Настройки для 30 Владимир Ярославль
    if (APP_TYPE === 'axis-one' && parseInt($user.idSklad) === 30) {
        options = {
            ...options,
            polotno: {
                'Стандарт': 'Стандарт',
                'Антикошка Pet Screen':'Антикошка Pet Screen',
                'Антикошка лайт': 'Антикошка лайт',
                'Антимошка Micro Mesh': 'Антимошка Micro Mesh',
                'Антипыльца противоаллергенная': 'Антипыльца противоаллергенная',
                'Maxi Vision': 'Maxi Vision',
                'Diamond Steel нерж. сталь': 'Diamond Steel нерж. сталь',

            },
        }
    }

    const polotno = options.polotno || {
        'Сетка москитная, стандарт': 'Стандарт',
        'Сетка москитная, Максимальный обзор': 'Максимальный обзор',
        'Сетка москитная, PPE': 'PPE',
        'Сетка москитная, АнтиМОШКА':'АнтиМОШКА',
        'Сетка москитная, Антикошка серебро': 'Антикошка серебро',
        'Сетка москитная, алюминиевая':'Алюминиевая',
        'Сетка москитная, антикошка белое':'Антикошка белое',
        'Сетка москитная, антикошка черное': 'Антикошка черное',
        'Сетка москитная, гипоаллергенная':'Гипоаллергенная',
        'Наносетка': 'Наносетка',
        'Оконный фильтр Оберег':'Оконный фильтр Оберег'
    }

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            // Обычная 1000×1450 Цветной Сетка москитная, Антикошка серебро без перемычки, крючок металлический, металлические уголки, металлическая ручка

            let title = item.title.split(' ', 3),
                inds = item.title.split(', ');

            width.set(title[1].split('x')[0]);
            height.set(title[1].split('x')[1]);
            ind1 = item.title.includes('без перемычки') ? 'Нет' : 'Есть';
            ind2.set(title[2]);

            let buf = item.title.split(', ');

            ind3 = Object.keys(polotno).find((el) => item.title.toLowerCase().includes(el.toLowerCase()));
            ind4 = inds[2];
            ind5 = buf.at(-2).split(' ')[0];
            ind6 = buf.at(-1).split(' ')[0];
            count.set(+item.quantity);
            comment.set(item.comment);

            fetchData = await fetch($ind2);
            change();
        }
    };

    const color = options.color || {
        'Белый':'Белый',
        'Коричневый(RAL8017)':'Коричневый(RAL8017)',
        'Цветной':'Цветной',
    }


    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('Раздвижка', '', color);
        let options = await network.fetch_ind('Раздвижка');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '800'),
        height = parameter('height', '1500'),
        ind1 = 'Есть', // перемычка
        ind2 = parameter('color', 'Белый'), // цвет
        ind3 = Object.keys(polotno).shift(), // полотно
        ind4 = '', //
        ind5 = '1', // колич сеток
        ind6 = '1000', //

        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch($ind2);

    const changeInd2 = () => {fetchData = fetch($ind2)};
    const changeHeight = _.debounce(() => {
        if ($height > 1400 && ind1 !== 'Есть') {
            ind1 = 'Есть';
            toastbox('toast-ind1', 3000);
        }
    }, 1000);

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,

            w = +$width,
            h = +$height
        ;

        let result = {
            type: 'раздвижка',
            name: 'Раздвижка',
            subname: [
                w + 'x' + h, ' ',
                $ind2, ' ', ind3, ' ',
                ind1 === 'Нет' ? 'без перемычки' : 'с перемычкой', ', ',
                ind5, ' шт., ', ind6, ' мм.напр.',
            ].join(''),
            title: [
                'Раздвижка', ' ', w + 'x' + h, ' ',
                $ind2, ' ', ind3, ' ',
                ind1 === 'Нет' ? 'без перемычки' : 'с перемычкой', ', ',
                ind5, ' шт., ', ind6, ' мм.напр.',
            ].join(''),
            params: {
                ind1: [ind1 === 'Нет' ? 'без перемычки' : 'с перемычкой', ', сеток ', ind5, ' шт, направляющая ', ind6, '  мм'].join(''),
                ind2: $ind2,
                ind3: ind3,
                ind4: w,
                ind5: h,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 39
        };

        _.forEach(data.result, function(item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;
            let kolvoSetok = ind5;


            if (name.includes('профиль') ) {
                kolvo = kolvoSetok * (((w ) * 2 + (h ) * 2) / 1000).toFixed(3);
            }

            if (name === 'шнур фиксирующий') {
                kolvo = kolvoSetok * (((w + h) * 2 + 60) / 1000).toFixed(3);
            }

            if (name.includes('фетр') ) {
                kolvo = kolvoSetok * (((w + h) * 2 ) / 1000).toFixed(3);
            }

            if (name.includes('направляющая') ) {
                kolvo = (((ind6) * 2 ) / 1000).toFixed(3);
            }

            if (
                (
                    name.includes('сетка москитная') ||
                    name.includes('наносетка') ||
                    name.includes('оберег')||
                    name.includes('антикошка')||
                    name.includes('нтипыльца')||
                    name.includes('micro')||
                    name.includes('vision')||
                    name.includes('нерж. сталь')
                ) && name.toLowerCase().indexOf(ind3.toLowerCase()) >= 0
            ) {
                kolvo =kolvoSetok *  (w * h / 1000000).toFixed(3);
            }

            if (name.includes('перемычка мс')) {
                if (ind1 === 'Есть') {
                    kolvo = kolvoSetok * ((w-60) / 1000).toFixed(3);
                }
            }

            if (name.includes('крепление мс перемычки')) {
                if (ind1 === 'Есть') {
                    kolvo = kolvoSetok * (2).toFixed(3);
                }
            }

            if (
                name.includes('без ролика')
            ) {
                kolvo =kolvoSetok *  (2).toFixed(3);
            }

            if (
                name.includes('с роликом')
            ) {
                kolvo = kolvoSetok * (2).toFixed(3);
            }



            if (name.includes('работа пс')) {
                if (
                    ind3.toLowerCase().includes('антикошка') ||
                    ind3.toLowerCase().includes('аллергенная') ||
                    ind3.toLowerCase().includes('наносетка')||
                    ind3.toLowerCase().includes('оберег')||
                    ind3.toLowerCase().includes('нерж. сталь')
                ) {
                    kolvo = kolvoSetok * (1).toFixed(3);
                }
            }
            else if (name.includes('работа')) {
                if (
                    ind3.toLowerCase().includes('стандарт') ||
                    ind3.toLowerCase().includes('ppe') ||
                    ind3.toLowerCase().includes('антимошка') ||
                    ind3.toLowerCase().includes('максимальный обзор') ||
                    ind3.toLowerCase().includes('Maxi Vision'.toLowerCase()) ||
                    ind3.toLowerCase().includes('нет')
                ) {
                    kolvo = kolvoSetok * (1).toFixed(3);
                }
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }
        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);

        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data.edIzmer["кв.м"], null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Москитное полотно</label>
                        <select class="form-control form-select" bind:value={ind3}>
                            {#each Object.entries(polotno) as [value, name]}
                                <option value="{value}">{name}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет</label>
                        <select class="form-control form-select" bind:value={$ind2} on:change={() => {changeInd2(); change()}}>
                            {#each Object.entries(color) as [value, name]}
                                <option value="{value}">{name}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">250 ≥ Шир., мм ≥ 1000</label>
                        <input type="number" class="form-control" step="10" min="250" max="{ options.max && options.max.width ? options.max.width : 1000 }" bind:value={$width} use:validate_int={$width}>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">250 ≥ Выс., мм ≥ 2100</label>
                        <input type="number" class="form-control" step="10" min="250" max="{ options.max && options.max.height ? options.max.height : 2100 }" bind:value={$height} use:validate_int={$height} on:change={changeHeight}>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Длина направляющих</label>
                        <input type="number" class="form-control" min="1" bind:value={ind6} use:validate_int={ind6}>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество сеток</label>
                        <input type="number" class="form-control" min="1" bind:value={ind5} use:validate_int={ind5}>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Перемычка</label>
                        <select class="form-control form-select" bind:value={ind1}>
                            <option value="Есть">Есть</option>
                            <option value="Нет">Нет</option>
                        </select>
                    </div>
                </div>
            </div>


        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>
            <RalColor color={$ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}

<div id="toast-ind1" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте больше 1400 мм рекомендуется поставить перемычку
        </div>
    </div>
</div>
